module.exports = __webpack_public_path__ + "86860574e15ea5c6bdab603df955248c.pdf";